var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4129 12.9944L15.3749 0.280837L0.00531958 4.03319L3.26961 7.52202L12.1832 2.63423L5.13796 9.5134L8.4129 12.9944Z",
    fill: "#B6B8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTelegram);
export default __webpack_public_path__ + "static/media/icn-telegram.d2a91b9586876420f02cb2b674946bf9.svg";
export { ForwardRef as ReactComponent };